/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Network { 
    /**
     * Elastic IPs
     */
    elastic_ip?: Array<string>;
    /**
     * Gateway
     */
    gateways?: Array<string>;
    /**
     * Network Interface IDs
     */
    network_interface?: Array<string>;
    /**
     * Security Group
     */
    security_group?: Array<string>;
    /**
     * Subnet IDs
     */
    subnets?: Array<string>;
    /**
     * VPCs
     */
    vpc?: Array<string>;
}

